import React from 'react'
import cx from 'classnames'

import { Item } from './common/Item/Item'

import styles from './List.module.scss'

export const List = ({
  ariaLabel,
  children,
  className = undefined,
  direction,
  tagName,
  ...restProps
}) => {
  const Component = tagName ?? 'ul'

  return (
    <Component
      aria-label={ariaLabel}
      className={cx(styles.list, styles.direction, {
        [styles[`direction-${direction}`]]: Boolean(direction),
        [className]: Boolean(className),
      })}
      {...restProps}
    >
      {children}
    </Component>
  )
}

List.Item = Item
